import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TeamsManagerLayer from '../components/teams/TeamsManagerLayer'


export const TeamsManagerListPage = () => {
  return (
    <MasterLayout>
        <TeamsManagerLayer />
    </MasterLayout>
  );
};
